import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILoginSuccessResponse } from '../../../entity/interface/iLoginEntities';

export interface ILoginCredentialsUseCase {
    execute(username: string, password: string, agent: string, tokenNeeded: boolean): Promise<ILoginSuccessResponse>;
}

export class LoginCredentialsUseCase implements ILoginCredentialsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        password: string,
        agent: string,
        tokenNeeded: boolean
    ): Promise<ILoginSuccessResponse> {
        return await this.userRepo.loginCredentials(username, password, agent, tokenNeeded);
    }
}
